export default [
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
  },
  {
    path: '/test/card',
    name: 'test-card',
    component: () => import('@/views/test/Test.vue'),
    meta: {
      pageTitle: 'Test',
      breadcrumb: [
        {
          text: 'Home',
        },
        {
          text: 'Test',
          active: true,
        },
      ],
    },
  },
]
